import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Palette {
    marketing: {
      deep: string
      forest: string
      sage: string
      mist: string
      paper: string
      linen: string
      sand: string
      peach: string
      ink: string
      muted: string
      border: string
      glow: string
    }
  }

  interface PaletteOptions {
    marketing?: {
      deep: string
      forest: string
      sage: string
      mist: string
      paper: string
      linen: string
      sand: string
      peach: string
      ink: string
      muted: string
      border: string
      glow: string
    }
  }
}

export const marketingTheme = createTheme({
  palette: {
    primary: {
      main: '#39544e',
      dark: '#2f4540',
      light: '#5f7a73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0f6b60',
      dark: '#083c36',
      light: '#5ea79a',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f4f7f4',
      paper: '#fdfbf8',
    },
    text: {
      primary: '#1d2c29',
      secondary: '#5f7772',
    },
    marketing: {
      deep: '#083c36',
      forest: '#0f6b60',
      sage: '#5ea79a',
      mist: '#d7ebe7',
      paper: '#f7f3ee',
      linen: '#fdfbf8',
      sand: '#e6d7c8',
      peach: '#f08541',
      ink: '#0c4e46',
      muted: '#5f7772',
      border: 'rgba(8, 60, 54, 0.12)',
      glow: 'rgba(160, 223, 211, 0.18)',
    },
  },
  shape: {
    borderRadius: 24,
  },
  typography: {
    fontFamily: '"Roboto", Arial, sans-serif',
    h1: {
      fontFamily: '"Roboto Slab", Georgia, serif',
      fontWeight: 700,
      letterSpacing: '-0.045em',
      lineHeight: 0.94,
    },
    h2: {
      fontFamily: '"Roboto Slab", Georgia, serif',
      fontWeight: 700,
      letterSpacing: '-0.035em',
      lineHeight: 0.98,
    },
    h3: {
      fontFamily: '"Roboto Slab", Georgia, serif',
      fontWeight: 700,
      letterSpacing: '-0.03em',
      lineHeight: 1.02,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shadows: [
    'none',
    '0 12px 28px rgba(2, 22, 19, 0.14)',
    '0 14px 26px rgba(7, 48, 43, 0.18)',
    '0 24px 60px rgba(7, 48, 43, 0.18)',
    ...Array.from({ length: 21 }, () => '0 24px 60px rgba(7, 48, 43, 0.18)'),
  ] as unknown as typeof createTheme extends (...args: any[]) => infer R ? R['shadows'] : never,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: 'smooth',
        },
        body: {
          overflowX: 'hidden',
          WebkitFontSmoothing: 'antialiased',
          backgroundColor: '#f4f7f4',
        },
        a: {
          color: 'inherit',
          textDecoration: 'none',
        },
        img: {
          maxWidth: '100%',
          display: 'block',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: '1.2rem',
          minHeight: '2.75rem',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 28,
        },
      },
    },
  },
})
